const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the rating configuration component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Categories} Categories injected to gain access to the Categories resource
 */
app.directive('ratingConfiguration', ['Authorization', 'CompanyIntegrations', function (Authorization, CompanyIntegrations) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '=',
        onChange: '&?'
      },
      template: require('../../../templates/directives/cms/rating-configuration.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.first = true;
        self.slackAvailable = false;
        self.instructions = '';
        self.subInstructions = '';

        self.onChange = function() {
          if ($scope.content.rating_configuration.notify_feedback_only && !$scope.content.rating_configuration.allow_feedback) {
            $scope.content.rating_configuration.notify_feedback_only = false;
          }

          if ($scope.onChange) {
            $scope.onChange({field: 'rating_configuration'});
          }

        };

        self.toggleAllow = function() {
          if (!$scope.content.rating_configuration.allow_rating && self.first) {
            $scope.content.rating_configuration.allow_feedback = true;
            $scope.content.rating_configuration.show_users_rating = true;
          }
          $scope.content.rating_configuration.allow_rating = !$scope.content.rating_configuration.allow_rating;
          self.first = false;
          self.onChange();
        };

        self.initialize = function() {
          if (!$scope.content.rating_configuration) {
            $scope.content.rating_configuration = {
              allow_rating: false,
              allow_feedback: false,
              notify_feedback_only: false,
              allow_edits: false,
              show_users_rating: false,
              total_value: 5,
              messaging: {
                individuals: [],
                slack_channels: []
              }
            };
          }
        };

        if (Authorization.getAuthToken().company.slack) {
          CompanyIntegrations.status({}, function (data) {
            var companyIntegration = data || {};

            self.slackAvailable = companyIntegration.slack || false;

          }, function (error) {
            console.log('Error occured getting company integration ', error);
          });
        }

        self.initialize();
      }],
      controllerAs: 'ratings'
    };
  }]);
